import { render, staticRenderFns } from "./StudentDisciplineSave.vue?vue&type=template&id=2a5457aa&"
import script from "./StudentDisciplineSave.vue?vue&type=script&lang=js&"
export * from "./StudentDisciplineSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports